<template>
  <div>
    <!-- <hom-header></hom-header> -->
    <!-- 搜索框、logo -->
    <Search class="search-sticky"></Search>
    <!-- 类型导航菜单 -->
    <!-- <TypeNav></TypeNav> -->
    <!-- 新增的首页横幅组件 -->
    <HomeBanner class="width_auto width_min"></HomeBanner>
    <applicationList class="width_auto width_min mb_16" :componentContent="appComponentContent"></applicationList>
    <productList class="width_auto width_min" :isShowShop="true" :componentContent="productComponentContent"></productList>

    <!-- <div style="height: 3000px;"></div> -->
    <!-- <CanvasPage :terminal="4" :typeId="1"></CanvasPage> -->

    <!-- 备案号 -->
    <div class="gateway_record">
      <div class="gateway_record_border">
        <div class="width_auto gateway_record_1">
          <div class="flex_a_c flex_j_c gap_8" v-for="(item, index) in gatewayRecord1" :key="index">
            <img style="width: 54px;height: 54px;" :src="require(`@/assets/iconfont/${item.icon}.png`)">
            <div class="color_4B5B76 fontS_20">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="gateway_record_border">
        <div class="width_auto gateway_record_2">
          <div class="flex_a_c flex_j_c gap_8" v-for="(item, index) in gatewayRecord2" :key="index">
            <img style="width: 32px;height: 32px;" :src="require(`@/assets/iconfont/${item.icon}.png`)">
            <div class="color_4B5B76 fontS_18">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="width_auto gateway_record_3">
        <div class="flex_a_c flex_j_c " v-for="(item, index) in footerNavLinks" :key="index">
          <el-divider v-if="index !== 0" direction="vertical"></el-divider>
          <div class="color_4B5B76 fontS_14 cur_p">{{ item.text }}</div>
        </div>
      </div>
      <div class="width_auto gateway_record_4">
        <div class="flex_a_c flex_j_c cur_p" v-for="(item, index) in gatewayRecord4" :key="index"
          @click="windowOpen(item)">
          <img style="height: 44px;" :src="require(`@/assets/iconfont/${item.icon}.png`)">
        </div>
      </div>
      <div class="width_auto gateway_record_5 flex_a_c gap_10">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
          沪ICP备2025135673号-1
        </a>
        <a target="_blank">
          沪B2-20251056
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CanvasPage from '@/components/canvasShow/canvasShowPage'
import HomHeader from '@/components/base/homHeader'
import Search from '@/components/base/Search'
import TypeNav from '@/components/base/TypeNav'
import HomeBanner from '@/components/home/HomeBanner' // 引入新组件
import applicationList from '@/components/canvasShow/basics/applicationList/pc/index' // 引入新组件
import productList from '@/components/canvasShow/basics/product/pc/index' // 引入新组件

export default {
  name: 'index',
  components: { HomHeader, CanvasPage, Search, TypeNav, HomeBanner, applicationList, productList },
  data () {
    return {
      canvasData: [],
      // topSearchShow: true, // 滚动后顶部搜索栏展示
      appComponentContent: {
        title: '应用列表',
        productData: {
          sourceType: '1',
          categoryId: 0,
          categoryName: '',
          imgTextData: [],
          productIdList: ['芒果TV', '爱奇艺', 'PPS', '美拍', '搜狐', 'PPTV', '电视猫', '土豆', 'bilibili', '优酷', '腾讯', 'PPTV', '电视猫', '土豆', 'bilibili', '优酷', '腾讯', 'PPTV', '电视猫', '土豆']
        },
        showMore: false,
        styleValue: '1',
        linkObj: {
          selsectValue: '',
          selectName: '',
          typeText: '',
          url: ''
        },
        hasDatas: true
      },
      productComponentContent: { 'title': '商品列表', 'productData': { 'sourceType': '1', 'categoryId': 0, 'categoryName': '', 'imgTextData': [], 'productIdList': [527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 594, 595, 598, 599] }, 'productRowNum': 9, 'productNum': 5, 'arrangeType': '多行多列', 'showMore': false, 'styleValue': '1', 'linkObj': { 'selsectValue': '', 'selectName': '', 'typeText': '', 'url': '' }, 'hasDatas': true },
      gatewayRecord1: [
        {
          icon: 'recordQuick',
          text: '同城仓储物流，快送小时达'
        },
        {
          icon: 'recordAI',
          text: '互联数字平台，智能生活圈'
        },
      ],
      gatewayRecord2: [
        {
          icon: 'Discount',
          text: '优惠活动不断'
        },
        {
          icon: 'Distribution',
          text: '同城一小时达'
        },
        {
          icon: 'Payment',
          text: '多方式支付'
        },
        {
          icon: 'CustomerService2',
          text: '24/7客服支持'
        },
        {
          icon: 'Points',
          text: '会员积分体系'
        },
        {
          icon: 'Product',
          text: '多种商品选择'
        }
      ],
      // 根据图片中的7个导航链接创建的数组
      footerNavLinks: [
        {
          text: '关于我们',
          href: '/about'
        },
        {
          text: '联系我们',
          href: '/contact'
        },
        {
          text: '联系客服',
          href: '/customer-service'
        },
        {
          text: '合作招商',
          href: '/cooperation'
        },
        {
          text: '商家文档',
          href: '/merchant-docs'
        },
        {
          text: '营销选品',
          href: '/marketing-selection'
        },
        {
          text: '移动端下载',
          href: '/mobile-download'
        }
      ],
      gatewayRecord4: [
        {
          icon: 'HarmfulInformationReporting',
          text: '网络APP举报下载',
          href: 'https://www.12377.cn/node_548446.htm'
        },
        {
          icon: 'OnlineHarmfulInformationReportingZone',
          text: '网上有害信息举报专区',
          href: 'https://www.12377.cn/'
        },
      ],
    }
  },
  mounted () {
    // let that = this
    // window.onscroll = function () {
    //   let top = document.documentElement.scrollTop || document.body.scrollTop
    //   if (top > 300) {
    //     that.topSearchShow = true
    //   } else {
    //     that.topSearchShow = false
    //   }
    // }
  },
  methods: {
    windowOpen (item) {
      window.open(item.href)
    },
  }

}
</script>
<style lang="scss" scoped>

.gateway_record {
  .gateway_record_border {
    border-bottom: 1px solid #E6E6E6;
  }

  .gateway_record_1 {
    height: 134px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 80px;
  }

  .gateway_record_2 {
    height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 65px;
  }

  .gateway_record_3 {
    height: 102px;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-divider {
      margin: 0 22px;
    }
  }

  .gateway_record_4 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  .gateway_record_5 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4B5B76;
    font-size: 14px;
    margin-bottom: 20px;
  }
}

.search-sticky {
  position: sticky;
  top: 36px;
  z-index: 30;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue